import { createInsertNodeAPI } from './pm-plugins/api';

/**
 * Content insertion plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 */
export var contentInsertionPlugin = function contentInsertionPlugin(_ref) {
  var _api$analytics;
  var api = _ref.api;
  var _createInsertNodeAPI = createInsertNodeAPI(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions),
    actions = _createInsertNodeAPI.actions,
    commands = _createInsertNodeAPI.commands;
  return {
    name: 'contentInsertion',
    actions: actions,
    commands: commands
  };
};